import { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { Link, useParams } from "react-router-dom";
import { useGetCustomerbyIdQuery, useGetOrderbyIdQuery } from "../../Services/CustomerAPI";
import { Table } from "react-bootstrap";

function AddCategory() {
    const { id } = useParams();
    const { data: customerDetail, isLoading, error, refetch } = useGetCustomerbyIdQuery(id);
    const { data: orderData } = useGetOrderbyIdQuery(id);

    console.log("orderData", orderData);
    useEffect(() => {
        refetch();
    }, [refetch]);

    if (isLoading) return <div class="loader"></div>;
    if (error) return <p>Failed to load Data</p>;

    const customer = customerDetail?.data;
    const billing = customer?.billing_address?.[0];
    const shipping = customer?.shipping_address?.[0];

    const orders = orderData?.data?.orders?.data || [];

    return (
        <div>
            <h3>Customer Details</h3>
            <div className="breadcrum mb-4">
                <p>
                    <Link to="/customer-list"><span>Customers</span></Link>
                    <FontAwesomeIcon icon={faAngleRight} className="mx-2" />
                    <span className="active-link">View</span>
                </p>
            </div>

            <div className="content-wrapper">
                {/* Customer Basic Details */}
                <div className="customer-info">
                    <h5 className="mt-5 mb-4">Basic Information</h5>
                    <p><strong>Name:</strong> {customer?.first_name} {customer?.last_name}</p>
                    <p><strong>Email:</strong> {customer?.email}</p>
                    <p><strong>Created At:</strong> {new Date(customer?.created_at).toLocaleDateString()}</p>
                </div>
                <hr />
                {/* Billing Address */}
                {billing && (
                    <div className="billing-address">
                        <h5 className="mt-5 mb-4">Billing Address</h5>
                        <p><strong>Name:</strong> {billing.first_name} {billing.last_name}</p>
                        <p><strong>Company:</strong> {billing.company_name}</p>
                        <p><strong>Country:</strong> {billing.country}</p>
                        <p><strong>Street:</strong> {billing.street_address}</p>
                        <p><strong>City:</strong> {billing.town_city}, {billing.state}</p>
                        <p><strong>Pin Code:</strong> {billing.pin_code}</p>
                        <p><strong>Phone:</strong> {billing.phone}</p>
                        <p><strong>Email:</strong> {billing.email}</p>
                        <hr />
                    </div>
                )}


                {/* Shipping Address */}
                {shipping && (
                    <div className="shipping-address">
                        <h5 className="mt-5 mb-4">Shipping Address</h5>
                        <p><strong>Name:</strong> {shipping.first_name} {shipping.last_name}</p>
                        <p><strong>Company:</strong> {shipping.company_name}</p>
                        <p><strong>Country:</strong> {shipping.country}</p>
                        <p><strong>Street:</strong> {shipping.street_address}</p>
                        <p><strong>City:</strong> {shipping.town_city}, {shipping.state}</p>
                        <p><strong>Pin Code:</strong> {shipping.pin_code}</p>
                        <p><strong>Phone:</strong> {shipping.phone}</p>
                        <p><strong>Email:</strong> {shipping.email}</p>
                    </div>
                )}
                <div className="table-responsive">
                    <h5 className="mt-5 mb-4">Order Details</h5>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Order ID</th>
                                <th>Track Order ID</th>
                                <th>Total Items</th>
                                <th>Subtotal</th>
                                <th>Total Discount</th>
                                <th>Final Total</th>
                                <th>Payment Type</th>
                                <th>Payment Status</th>
                                <th>Order Status</th>

                            </tr>
                        </thead>
                        <tbody>
                            {orders.length > 0 ? (
                                orders.map((order) => (
                                    <tr key={order.id}>
                                        <td>{order.order_id}</td>
                                        <td>{order.track_order_id}</td>
                                        <td>{order.total_items}</td>
                                        <td>${order.subtotal_selling_price}</td>
                                        <td>${order.total_discount}</td>
                                        <td>${order.final_total_amount}</td>
                                        <td>{order.payment_type === 0 ? "COD" : "Online"}</td>
                                        <td>{order.payment_status}</td>
                                        <td>{order.order_status === "order_placed"
                                            ? "Order Placed"
                                            : order.order_status === "processing"
                                                ? "Processing"
                                                : order.order_status === "shipped"
                                                    ? "Shipped"
                                                    : order.order_status === "delivered"
                                                        ? "Delivered"
                                                        : order.order_status === "cancelled"
                                                            ? "Cancelled"
                                                            : "Unknown Status"}</td>

                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="14" style={{ textAlign: "center" }}>No orders available</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>

            </div>
        </div>
    );
}

export default AddCategory;
